import $ from "jquery";
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import Buttons from '@material-ui/core/Button';
import { Grid, Input } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';



import './bankdetails.css';
import Setexecutive from './executive';
import Loading from '../../loading';
import Server from '../../../functions/server';


class Customer extends Component {

  state = {
    opendialog: false,
    load: false,
    deleteid: 0
  }

  removeBankDetails() {
    let context = this;
    let data = {'id': this.state.deleteid};
    context.setState({
      load: true,
      opendialog: false,
      message: 'Removing Bank details!!!'
    });
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'bankdetails/delete.php',
      success: function(data)
      {
        if (data == 1) {
          context.setState({
            load: false
          });
          context.update(context.state.deleteid);
        }
      },
      error: function(e)
      {
        context.setState({
          load: false
        });
      }
    });
  }

  update(id) {
    let data = this.props.data;
    let dele = [];
    data.map((del) => {
      if (del.id == id) {
        return;
      }
      else {
        dele.push(del);
      }
    });
    this.props.updateData(dele);
  }

  delete(id) {
    this.setState({
      opendialog: true,
      deleteid: id
    })
  }

  edit(id, name, account, ifsc, payee) {
    this.setState({
      openEdit: true,
      id: id,
      name: name,
      account: account,
      ifsc: ifsc,
      payee: payee
    })
  }

  handleClose(){
    this.setState({
      opendialog: false
    })
  }

  closeedit(val) {
    this.setState({
      openEdit: val
    })
  }

  updatedetails(){
    let context = this;
    let id = this.state.id;
    let olddata = context.props.data;
    let name= this.state.name;
    let account= this.state.account;
    let ifsc= this.state.ifsc;
    let payee= this.state.payee;
    if (name == '' || name == undefined || name == null) {
      alert('Enter the Bank Name!!!');
      return;
    }
    if (account == '' || account == undefined || account == null) {
      alert('Enter the ACCOUNT NUMBER!!!');
      return;
    }
    if (ifsc == '' || ifsc == undefined || ifsc == null) {
      alert('Enter the IFSC CODE!!!');
      return;
    }
    if (payee == '' || payee == undefined || payee == null) {
      alert('Enter the Payee Name!!!');
      return;
    }
    let data = {'id': id, 'name': name, 'account': account, 'ifsc': ifsc,
                'payee': payee};
    context.setState({
      load: true,
      message: 'Updating Bank Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'bankdetails/update.php',
      success: function(data)
      {
        context.setState({
          openEdit: false,
          load: false
        })
        if (data == 1) {
          for (var i = 0; i < olddata.length; i++) {
            if (id == olddata[i].id) {
              olddata[i].bank_name = name;
              olddata[i].account = account;
              olddata[i].ifsc_code = ifsc;
              olddata[i].payee_name = payee;
            }
          }
          context.props.updateData(olddata);
        }
      },
      error: function(e)
      {
        alert('Try again');
        context.setState({
          load: false
        })
      }
    });
  }

  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  render() {
    const { fullScreen } = this.props;
    let { opendialog, openEdit, executive, load, message } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    let dialog, edit;
    if(opendialog) {
      dialog = (
          <Dialog open={opendialog} onClose={this.handleClose.bind(this)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{"Alert"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Dont you want to remove
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Buttons onClick={this.handleClose.bind(this)} color="secondary">
                NO
              </Buttons>
              <Buttons onClick={this.removeBankDetails.bind(this, this.props.id)}
                color="primary" autoFocus>
                Yes
              </Buttons>
            </DialogActions>
          </Dialog>
      )
    }
    if (openEdit) {
      edit = (
        <Dialog fullScreen={fullScreen} open={openEdit}
         onClose={this.handleClose.bind(this)}
         aria-labelledby="responsive-dialog-title">
          <DialogTitle id="responsive-dialog-title"
            style={{width: 500}}>{"Add Bank Details"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Bank Name<br/>
                <Input value={this.state.name} fluid focus
                  onChange={this.onChange('name')}
                  placeholder='Bank name' />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Account Number<br/>
                <Input value={this.state.account} fluid focus
                  onChange={this.onChange('account')}
                  placeholder='Account Number' />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                IFSC CODE<br/>
                <Input value={this.state.ifsc} fluid focus
                  onChange={this.onChange('ifsc')}
                  placeholder='IFSC CODE' />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Payee Name<br/>
                <Input value={this.state.payee} fluid focus
                  onChange={this.onChange('payee')}
                  placeholder='Payee Name' />
              </Grid.Column>
            </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={this.closeedit.bind(this, false)} color="secondary">
              Cancel
            </Buttons>
            <Buttons onClick={this.updatedetails.bind(this, this.props.id)}
              color="primary" autoFocus>
              Submit
            </Buttons>
          </DialogActions>
        </Dialog>
      )
    }
    return (
      <div>
        <Paper>
          <table id='emp_table' width="100%">
              <tr id='tableheader'>
                <th id='thtitle1' style={{width: '5%'}}><b>S.No</b></th>
                <th id='thtitle1' style={{width: '5%'}}><b>BankId</b></th>
                <th id='thtitle' style={{width: '15%'}}>Bank Name</th>
                <th id='thtitle' style={{width: '15%'}}><b>Account Number</b></th>
                <th id='thtitle1' style={{width: '10%'}}><b>IFSC</b></th>
                <th id='thtitle' style={{width: '15%'}}><b>Payee Name</b></th>
                <th id='thtitle' style={{width: '30'}}><b>Executive</b></th>
                {
                  this.props.menuPermission.edit ?
                  <th id='thtitle' style={{width: '5%'}}><b><center>Edit</center></b></th>:''
                }
                
                {
                  this.props.menuPermission.cancel ?
                  <th id='thtitle'  style={{width: '5%'}}><b><center>Delete</center></b></th>:''
                }
                
              </tr>
              {this.props.data.map((z) => {
                  if (z.type == 'bank') {
                    return (
                      <tr id='tablerow'>
                        <td style={{fontSize: 12 }}><center>{z.sino}</center></td>
                        <td style={{fontSize: 12 }}><center>{z.id}</center></td>
                        <td style={{fontSize: 12 }}><center>{z.bank_name}</center></td>
                        <td style={{fontSize: 12 }}><center>{z.account}</center></td>
                        <td style={{fontSize: 12 }}><center>{z.ifsc_code}</center></td>
                        <td style={{fontSize: 12 }}><center>{z.payee_name}</center></td>
                        
                        <td style={{fontSize: 12 }}>
                          <center>
                            <Setexecutive menuPermission={this.props.menuPermission} data={this.props.data}
                              executive={this.props.executive} id={z.id} bankeditcontrol={this.props.bankeditcontrol} />
                          </center>
                        </td>
                        {
                          this.props.menuPermission.edit ?
                          <td style={{cursor: 'pointer', display: this.props.bankeditcontrol}}
                              onClick={this.edit.bind(this, z.id, z.bank_name, z.account,
                              z.ifsc_code, z.payee_name)}>
                            <center>Edit</center>
                          </td>:''
                        }

                        {
                          this.props.menuPermission.cancel ?
                          <td style={{cursor: 'pointer', display: this.props.bankeditcontrol}} onClick={this.delete.bind(this, z.id)}>
                            <center>Delete</center>
                          </td>:''
                        }
                        
                        
                      </tr>
                    );
                  }
                }
              )}
          </table>
        </Paper>
        {dialog}
        {edit}
        {loading}
      </div>
    );
  }
}

export default Customer;
